import { IOrderQuotation } from '../order-quotation-form';
import { ValidationError } from 'yup';

// Uniqueness applies only to lines that HAVE a product. Two free lines (both
// product === null) are not duplicates — that early return is what allows a
// cotización to carry several unspecified free lines.
export function isProductUnique(
    value: any,
    context: any,
): boolean | ValidationError {
    const { product } = context.from[0]
        .value as IOrderQuotation['order_quotation_products'][number];

    if (!product) return true;

    const orderQuotation = context.from[1].value as IOrderQuotation;
    const order_quotation_products = orderQuotation.order_quotation_products;

    const product_id = product.id;

    const results = order_quotation_products.filter((pProduct: any) => {
        const product_id_2 = pProduct.product ? pProduct.product.id : null;
        return product_id === product_id_2;
    });

    if (!(results.length <= 1)) {
        return context.createError({
            message: `El producto no es unico`,
        });
    }

    return true;
}
